// Generated by CoffeeScript 2.7.0
var GenerateCascadedSelectsSidebar;

import CascadedSelectListItem from './cascaded_selects_list_item.js';

import EditCascadedSelectModal from './cascaded_selects_modal/edit_cascaded_selects_modal.js';

import ImportCascadedSelectsModal from './cascaded_selects_modal/import_cascaded_selects_modal.js';

export var CascadedSelectsSidebar = Vue.extend({
  components: {
    "cascaded-select-list-item": CascadedSelectListItem
  },
  props: {
    initialSelectedId: {
      type: String
    }
  },
  data: function() {
    return {
      selectedId: this.initialSelectedId,
      cascadedSelectsOptions: [],
      resourceUrl: "/admin/cascaded_selects",
      scrollTop: 0
    };
  },
  template: `<div class="cascaded-selects-sidebar" cascaded-selects-has-navigator>
  <div class="sidebar-head">
    <button class="text-btn btn-primary"
            @click="openCascadedSelectModalFunc">
      <i class="slp-plus-circle"></i>
      <span>新增级联选择</span>
    </button>
    <div class="btn text-btn btn-primary"
         @click="openImportCascadedSelectsModalFunc">
      <i class="slp-download-o"></i>
      <span>导入数据</span>
    </div>
  </div>
  <div class="list-content"
       v-if='cascadedSelectsOptions.length'
       @scroll="sidebarScrollFunc"
       ref="sidebarContentRef">
    <cascaded-select-list-item v-for="cascadedSelect in cascadedSelectsOptions"
                               :key="cascadedSelect.id"
                               :selectedId="selectedId"
                               :resourceUrl="resourceUrl"
                               :cascadedSelectOption="cascadedSelect"
                               @selectedCascadedSelectChange="selectedcascadedSelectChangeFunc"
                               @deletedCascadedSelect="updateCascadedSelectOption"
                               @cascadedSelectChanged="cascadedSelectChangedFunc" />
  </div>
  <div class="list-content" v-else>
    <div class="no-data">暂无级联选择</div>
  </div>
</div>`,
  created: function() {
    return this.doRequest();
  },
  watch: {
    selectedId: function(val) {
      if (val) {
        return Turbolinks.visit(`/admin/cascaded_selects/${this.selectedId}`);
      } else {
        return Turbolinks.visit("/admin/cascaded_selects");
      }
    }
  },
  methods: {
    doRequest: function() {
      return new Skylark.Libs.PaginatedResources(this.resourceUrl, {
        callback: (data) => {
          return this.cascadedSelectsOptions = this.cascadedSelectsOptions.concat(data);
        },
        completedCallback: () => {
          var ref;
          if (!this.selectedId) {
            return this.selectedId = (ref = this.cascadedSelectsOptions[0]) != null ? ref.id : void 0;
          }
        }
      });
    },
    selectedcascadedSelectChangeFunc: function(id) {
      return this.selectedId = id;
    },
    updateCascadedSelectOption: function(deletedId) {
      var ref;
      this.cascadedSelectsOptions = _.reject(this.cascadedSelectsOptions, function(option) {
        return option.id === deletedId;
      });
      if (this.selectedId === deletedId) {
        this.resetScrollTop();
        return this.selectedId = (ref = this.cascadedSelectsOptions[0]) != null ? ref.id : void 0;
      }
    },
    openCascadedSelectModalFunc: function() {
      return new EditCascadedSelectModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('edit-cascaded-select-modal'),
        propsData: {
          title: '新建级联选择',
          initialCascadedSelect: {
            labels: ['第一层级'],
            name: '新级联选择'
          },
          callback: (cascaded_select) => {
            return this.addCascadedSelectFunc(cascaded_select);
          }
        }
      });
    },
    openImportCascadedSelectsModalFunc: function() {
      return new ImportCascadedSelectsModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('import-cascaded-selects-modal')
      });
    },
    addCascadedSelectFunc: function(cascaded_select) {
      return Skylark.Libs.Ajax.post(`${this.resourceUrl}`, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: {
          cascaded_select: cascaded_select
        },
        success: (data) => {
          this.cascadedSelectsOptions.push(data);
          return Skylark.Bridge.newAlertify('新增成功', {
            type: 'success'
          });
        },
        error: function(xhr, status, errors) {
          return Skylark.Bridge.newAlertify(errors.join('，'), {
            type: 'error'
          });
        }
      });
    },
    cascadedSelectChangedFunc: function(cascaded_select) {
      _.find(this.cascadedSelectsOptions, function(option) {
        var flag;
        flag = option.id === cascaded_select.id;
        if (flag) {
          _.extend(option, cascaded_select);
        }
        return flag;
      });
      return Turbolinks.visit();
    },
    sidebarScrollFunc: function(e) {
      return this.scrollTop = e.target.scrollTop;
    },
    resetScrollTop: function() {
      this.scrollTop = 0;
      return this._setSidebarScrollTop();
    },
    _setSidebarScrollTop: function() {
      if (this.$refs.sidebarContentRef) {
        return this.$refs.sidebarContentRef.scrollTop = this.scrollTop;
      }
    }
  }
});

export default GenerateCascadedSelectsSidebar = {
  _generateCascadedSelectsSidebar: function(initialSelectedId) {
    var navigator_el;
    navigator_el = DomMaster.find('[cascaded-selects-has-navigator]');
    this.sidebarVm = navigator_el.isPresent() ? navigator_el.node.__vue__ : new CascadedSelectsSidebar({
      el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('cascaded_selects_sidebar'),
      propsData: {
        initialSelectedId: initialSelectedId
      }
    });
    return this.sidebarVm._setSidebarScrollTop();
  }
};
